/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://coffeescript.org/

// $(document).on('ready page:load', function() {
//   $('#challenge-tags').tagit({
//     fieldName:   'tag_list',
//     singleField: true
//   });
//   $('#challenge-tags').tagit();
//   const tag_string = $("#tag_hidden").val();
//   try {
//     const tag_list = tag_string.split(',');
//     return Array.from(tag_list).map((tag) =>
//       $('#challenge-tags').tagit('createTag', tag));
//   } catch (error) {}
// });



$(document).ready(function() {

  $('#user-tags').tagit({
    fieldName:   'tag_contents',
    singleField: true,

  });
  $('#user-tags').tagit();
  const tag_string = $("#tag_hidden").val();
  try {
    const tag_list = tag_string.split(',');
    for (var i = 0, size = tag_list.length; i < size; ++i){
      tag = tag_list[i];
      $('#user-tags').tagit('createTag', tag);
    }
  } catch (error) {}
});
